import { withError } from 'mdlkit';
import Password from './Password';

export default withError(Password);
